import { useState } from "react";
import useAppStore from "../../store/AppStore";
import styles from "./InnerButton.module.css";
import useComponentsStore from "../../store/componentsStateStore";
import { getGeneralImage, styleHelper } from "../../helpers/commonFunctions";
import {InnerButtonDataType} from "../../interfaces/innerButton/InnerButton.type";
const InnerButton = ({ item }: { item: InnerButtonDataType }) => {
    const innerBtn = item?.inner;
    const contentBox = innerBtn?.contentBox;
    const payLoad = innerBtn?.payload;
    const status = innerBtn?.status;
    const { isDeviceMobile } = useAppStore();
    const [isLoading, setIsLoading] = useState(false);
    const { continueDraft } = useComponentsStore();

    const onClickHandler = async () => {
        if (status === false || isLoading) return;
        try {
            setIsLoading(true);
            await continueDraft(payLoad);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };
    return (

            <button
                className={`vas-text-18 vas-btn vas-w-100 vas-fw-bold vas-p-3 vas-d-flex vas-align-items-center vas-justify-content-center vas-border-radius ${
                    styles.sticky_button
                }`}
                style={styleHelper({
                    backgroundColor: innerBtn?.backgroundColor,
                    border: `2px solid ${innerBtn?.borderColor}`
                })}
                onClick={onClickHandler}
            >
      <span className={`vas-gap-1 ${styles.centered_content} vas-align-items-center vas-justify-content-center`}>
        <span style={styleHelper({color: contentBox?.textColor})}>
          {contentBox?.text}{" "}
        </span>
          {isLoading ? (
              <i className="vas-spinner-border vas-text-white vas-spinner-border-sm vas-p-2"/>
          ) : contentBox?.icon ? (
              <img
                  className="vas"
                  src={getGeneralImage(contentBox?.icon)}
                  alt="sticky_icon"
                  height={30}
                  width={30}
              />
          ) : (
              <></>
          )}
      </span>
            </button>
    );
};

export default InnerButton;
